import { render, staticRenderFns } from "./companyIntro.vue?vue&type=template&id=466d204e&scoped=true"
import script from "./companyIntro.vue?vue&type=script&lang=js"
export * from "./companyIntro.vue?vue&type=script&lang=js"
import style0 from "./companyIntro.vue?vue&type=style&index=0&id=466d204e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d204e",
  null
  
)

export default component.exports